import { s3UserImages } from '../actions';

const initialState = {
  images: [],
  imagesMetaData: {},
  signedImageURLs: {},
  signedThumbnailURLs: {}
};

const s3UserImages_reducers = (state = initialState, action) => {
  let newstate;
  switch (action.type) {
    case s3UserImages.types.FETCHINGUSERIMAGES:
      newstate = {
        fetchUserImages: action.type
      };
      return { ...state, ...newstate };
    case s3UserImages.types.FETCHEDUSERIMAGES:
      newstate = {
        fetchUserImages: action.type,
        images: action.data.Contents
      };
      return { ...state, ...newstate };
    case s3UserImages.types.FETCHUSERIMAGESFAILED:
      newstate = {
        fetchUserImages: action.type
      };
      return { ...state, ...newstate };
    case s3UserImages.types.FETCHINGUSERIMAGEMETADATA:
      newstate = {
        fetchUserImageMetaData: action.type
      };
      return { ...state, ...newstate };
    case s3UserImages.types.FETCHEDUSERIMAGEMETADATA:
      newstate = {
        fetchUserImageMetaData: action.type,
        imagesMetaData: {
          ...state.imagesMetaData,
          [action.key]: action.data.Metadata
        }
      };
      return { ...state, ...newstate };
    case s3UserImages.types.FETCHUSERIMAGEMETADATAFAILED:
      newstate = {
        fetchUserImageMetaData: action.type
      };
      return { ...state, ...newstate };
    case s3UserImages.types.GETTINGS3IMAGESIGNEDURL:
      newstate = {
        getSignedS3ImageURL: action.type
      };
      return { ...state, ...newstate };
    case s3UserImages.types.GETS3IMAGESIGNEDURL:
      newstate = {
        getSignedS3ImageURL: action.type,
        signedImageURLs: {
          ...state.signedImageURLs,
          [action.imageKey]: action.imageURL
        },
        signedThumbnailURLs: {
          ...state.signedThumbnailURLs,
          [action.thumbKey]: action.thumbURL
        }
      };
      return { ...state, ...newstate };
    case s3UserImages.types.GETS3IMAGESIGNEDURLFAILED:
      newstate = {
        getSignedS3ImageURL: action.type
      };
      return { ...state, ...newstate };
    case s3UserImages.types.DOWNLOADINGALTERNATESIZE:
      newstate = {
        images: state.images.map(image => {
          return image.Key === action.key
            ? {
                ...image,
                downloading: action.Size
              }
            : image;
        })
      };
      return { ...state, ...newstate };
    case s3UserImages.types.ALTERNATESIZEDONE:
      newstate = {
        images: state.images.map(image => {
          return image.Key === action.key
            ? {
                ...image,
                downloading: ''
              }
            : image;
        })
      };
      return { ...state, ...newstate };
    default:
      return state;
  }
};

export default s3UserImages_reducers;



// WEBPACK FOOTER //
// ./src/store/reducers/s3UserImages.js